import React from 'react';
import './Referral.css';

const Referral = ({ copyRefSite, copyRefBot, copiedRefSite, copiedRefBot, referralStats }) => {
  const { referral_count = 0, total_bonus_days = 0, referral_link = '', referral_bot_link = '' } = referralStats || {};

  return (
    <div className="referral-container">
      <div className="ref-grid">
        <div className="ref-stat">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7">
            <circle cx="9" cy="8" r="3.2" />
            <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
            <path d="M16 5.5a3 3 0 0 1 0 5.5" />
          </svg>
          <div>
            <div className="ref-stat-label">Приглашено</div>
            <div className="ref-stat-value">{referral_count}</div>
          </div>
        </div>
        <div className="ref-stat">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7" strokeLinejoin="round">
            <rect x="3" y="8" width="18" height="13" rx="2" />
            <path d="M3 12h18M12 8v13M12 8C10 4 5 4 6.5 8M12 8c2-4 7-4 5.5 0" />
          </svg>
          <div>
            <div className="ref-stat-label">Бонусных дней</div>
            <div className="ref-stat-value">{total_bonus_days}</div>
          </div>
        </div>
      </div>

      <div className="ref-info">
        <div className="ref-info-title">Как это работает</div>
        <div className="ref-info-text">
          <p><strong>За каждого друга:</strong></p>
          <ul style={{ paddingLeft: '20px', margin: '8px 0 0 0', listStyle: 'none' }}>
            <li style={{ marginBottom: '4px' }}>+7 дней сразу после его перехода</li>
            <li style={{ marginBottom: '4px' }}>+21 день после первой оплаты друга</li>
            <li style={{ marginBottom: '0' }}>А другу — бонус +14 дней после оплаты!</li>
          </ul>
        </div>
      </div>

      <div className="ref-links">
        <div className="ref-links-title">Ваши реферальные ссылки</div>
        <div className="ref-link-row">
          <span className="ref-link-label">Сайт:</span>
          <span className="ref-link-url">{referral_link || 'https://risevpn.io/register?ref=...'}</span>
          <button onClick={copyRefSite} className="ref-link-copy">
            {copiedRefSite ? <span style={{ color: '#4aae88' }}>✓</span> : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect x="8.5" y="8.5" width="12" height="12" rx="2.5" />
                <path d="M15.5 8.5V6a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2.5" />
              </svg>
            )}
          </button>
        </div>
        <div className="ref-link-row">
          <span className="ref-link-label">Бот:</span>
          <span className="ref-link-url">{referral_bot_link || 'https://t.me/risevpn_bot?start=...'}</span>
          <button onClick={copyRefBot} className="ref-link-copy">
            {copiedRefBot ? <span style={{ color: '#4aae88' }}>✓</span> : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <rect x="8.5" y="8.5" width="12" height="12" rx="2.5" />
                <path d="M15.5 8.5V6a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2.5" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Referral;